import {
  LinearProgress,
  Tooltip,
  IconButton,
  Icon,
  Stack,
  Button,
  Box,
} from "@mui/material";
import "./style.css";
import MDDataGrid from "components/MDDataGrid/MDDataGrid";
import MDTypography from "components/MDTypography";
import { centsToDollars } from "global/functions";
import MDBadge from "components/MDBadge";
import { useMaterialUIController } from "context";
import { debounce, get, isEmpty } from "lodash";
import MDBox from "components/MDBox";
import EmptyTableRowOverlay from "components/MDEmptyOverlay/EmptyTableRowOverlay";
import { useEffect, useMemo, useState } from "react";
import { getSubscriptionDuration } from "global/functions";
import CircularIndeterminate from "components/MDLoading";
import MDSnackbar from "components/MDSnackbar";
import { mobileNumberMasking } from "global/functions";
import { getHours } from "global/functions";
import MDButton from "components/MDButton";
import RefundDialog from "./RefundDialog";
import { getReservations } from "store/slice/reservation/reservationSlice";
import { useDispatch, useSelector } from "react-redux";
import BallparkDialog from "./ballparkDialog";
import PaymentFailedInfoDialog from "./paymentFailedInfoDialog";
import LicensePlateUpdate from "./LicensePlateUpdateDialog";
import SpaceNumberUpdate from "./SpaceNumberUpdateDialog";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  dockRevenueTransfer,
  dockTransferInfo,
} from "store/slice/payment/paymentSlice";
import ConfirmationDialog from "components/Common/ConfirmationDialog";
import DockTransferInfoDialog from "./DockTransferInfo";
import ErrorIcon from "@mui/icons-material/Error";
import Chip from "@mui/material/Chip";
import { formatDateWithTimezone } from "global/functions";

const ReservationsTable = (props) => {
  const dispatch = useDispatch();
  const [controller] = useMaterialUIController();
  const [pageSize, setPageSize] = useState(25);
  const [page, setPage] = useState(0);
  const { sidenavColor } = controller;
  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const [updateLicensePlateData, setUpdateLicensePlateData] = useState({});
  const [updateSpaceNumberData, setUpdateSpaceNumberData] = useState({});
  const [licensePlateUpdateDialogOpen, setLicensePlateUpdateDialogOpen] =
    useState(false);

  const [spaceNumberUpdateDialogOpen, setSpaceNumberUpdateDialogOpen] =
    useState(false);

  const [issueRefundData, setIssueRefundData] = useState("");
  const [fullRefund, setFullRefund] = useState(false);
  const [ballparkView, setBallparkView] = useState(false);
  const [ballparkData, setBallparkData] = useState("");
  const [failedViewReason, setFailedViewReason] = useState(false);
  const [failedReasonData, setFailedReasonData] = useState("");
  const [filterModel, setFilterModel] = useState({
    items: [],
  });
  const [retryDialogOpen, setRetryDialogOpen] = useState(false);
  const [retryTransferRow, setRetryTransferRow] = useState(null);
  const [retryLoading, setRetryLoading] = useState(false);
  const [transferInfoOpen, setTransferInfoOpen] = useState(false);
  const [transferInfoLoading, setTransferInfoLoading] = useState(false);
  const [transferInfo, setTransferInfo] = useState(null);
  const [selectedTransferRow, setSelectedTransferRow] = useState(null);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(
    JSON.parse(localStorage.getItem("dataGridColumnVisibility")) || {},
  );
  const [columnOrder, setColumnOrder] = useState(
    JSON.parse(localStorage.getItem("dataGridColumnOrder")) || [],
  );

  const {
    placeId,
    startDate,
    endDate,
    searchText,
    tz,
    activeTab,
    isRefundIssued,
    setIsRefundIssued,
  } = props;

  const reservationsList = useSelector(
    (state) => state.reservations?.reservationsList,
  );
  const totalReservations = useSelector(
    (state) => state.reservations?.totalReservations,
  );

  const loading = useSelector(
    (state) => state.reservations?.loading || state.payment?.loading,
  );
  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification((prev) => ({ ...prev, show: false })),
  });
  const [sortModel, setSortModel] = useState([]);
  const userData = useSelector((state) => state.users?.meInfo);
  const roleModules = userData?.roleModules || {};

  const handleFilterChange = (newFilterModel) => {
    setFilterModel(newFilterModel);
  };

  const handleColumnVisibilityChange = (newColumnVisibilityModel) => {
    setColumnVisibilityModel(newColumnVisibilityModel);
    localStorage.setItem(
      "dataGridColumnVisibility",
      JSON.stringify(newColumnVisibilityModel),
    );
  };

  const handleColumnOrderChange = (newColumnOrder) => {
    setColumnOrder(newColumnOrder);
    localStorage.setItem("dataGridColumnOrder", JSON.stringify(newColumnOrder));
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  useEffect(() => {
    const savedVisibility = JSON.parse(
      localStorage.getItem("dataGridColumnVisibility"),
    );
    if (savedVisibility) {
      setColumnVisibilityModel(savedVisibility);
    }
    const savedOrder = JSON.parse(localStorage.getItem("dataGridColumnOrder"));
    if (savedOrder) {
      setColumnOrder(savedOrder);
    }
  }, []);

  const handleViewTransferInfo = async (row) => {
    try {
      setTransferInfoLoading(true);

      const response = await dispatch(
        dockTransferInfo({
          reservationId: row._id,
        }),
      ).unwrap();

      setTransferInfo(response?.dockTransfer || {});
      setSelectedTransferRow(row);
      setTransferInfoOpen(true);
    } catch (error) {
      setNotification({
        color: "error",
        icon: "warning",
        title: "Error",
        content: error?.message || "Unable to fetch transfer info",
        show: true,
      });
    } finally {
      setTransferInfoLoading(false);
    }
  };

  const handleRetryTransfer = async () => {
    try {
      if (!retryTransferRow?.transactionId) {
        return;
      }
      setRetryLoading(true);
      const response = await dispatch(
        dockRevenueTransfer({
          paymentIntentId:
            transferInfo?.paymentIntentId || retryTransferRow?.transactionId,
        }),
      ).unwrap();

      if (response?.success) {
        setNotification({
          color: "success",
          icon: "check",
          title: "Transfer Success",
          content: "Dock revenue transferred successfully",
          show: true,
        });
        setTransferInfoOpen(false);
        setTransferInfo(null);

        getReservationsData(page);
      } else {
        setNotification({
          color: "error",
          icon: "warning",
          title: "Transfer Failed",
          content: response?.message || "Retry failed",
          show: true,
        });
      }
    } catch (error) {
      setNotification({
        color: "error",
        icon: "warning",
        title: "Transfer Failed",
        content: error?.message || "Something went wrong",
        show: true,
      });
    } finally {
      setRetryLoading(false);
      setRetryDialogOpen(false);
      setRetryTransferRow(null);
    }
  };

  const columnsData = [
    {
      field: "orderId",
      headerName: "ID",
      width: 120,
      editable: false,
      renderCell: ({ row }) => {
        let color;
        switch (row.status) {
          case "failed":
            color = "red";
            break;
          case "refunded":
            color = "#1b6be4";
            break;
        }

        return (
          <MDTypography display="block" variant="caption" style={{ color }}>
            {row.purpose === "PARKING"
              ? row.transientNumber || "-"
              : row.subscriptionNumber || "-"}
          </MDTypography>
        );
      },
    },
    {
      field: "licensePlate",
      headerName: "License Plates",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <div
          className="rowscroll"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {row.licensePlate.map((plate, index) => (
            <strong key={index}>
              {plate}
              {index < row.licensePlate.length - 1 ? ", " : ""}
            </strong>
          ))}

          {row.purpose === "PARKING" && (
            <Tooltip title="Edit License plate" placement="top">
              <IconButton
                onClick={() => {
                  setUpdateLicensePlateData({
                    reservationId: row._id,
                    licensePlate: row.licensePlate,
                  });
                  setLicensePlateUpdateDialogOpen(true);
                }}
              >
                <Icon fontSize="small">edit</Icon>
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      field: "parkerName",
      headerName: "Parker Name",
      width: 180,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${row?.parkerName || "-"}`}
        </MDTypography>
      ),
    },
    {
      field: "parkerEmail",
      headerName: "Parker Email",
      width: 180,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${row?.parkerEmail || row.customerId?.email || "-"}`}
        </MDTypography>
      ),
    },
    {
      field: "transactionDate",
      headerName: "Transaction Date",
      width: 150,
      type: "date",
      editable: false,
      valueGetter: (params) => {
        if (!params || !params.row) return null;

        const row = params.row;
        const value =
          row.status === "refunded"
            ? get(row, "refundDate", row.transactionDate)
            : row.transactionDate;

        return value ? new Date(value) : null;
      },
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${
            formatDateWithTimezone(
              row.status === "refunded"
                ? get(row, "refundDate", row.transactionDate)
                : row.transactionDate,
              row?.placeId?.timeZoneId,
            ) || "-"
          }`}
        </MDTypography>
      ),
    },

    {
      field: "duration",
      headerName: "Duration",
      width: 300,
      type: "date",
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption">
          {getSubscriptionDuration({
            startDate: row.startDate,
            endDate: row.endDate,
            tz: get(row, "placeId.timeZoneId", ""),
            isReservation: true,
          })}
        </MDTypography>
      ),
    },
    {
      field: "hours",
      headerName: "Hours",
      type: "number",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption">
          {getHours({ startDate: row.startDate, endDate: row.endDate })}
        </MDTypography>
      ),
    },
    {
      field: "rate",
      headerName: "Rate",
      width: 250,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption">
          {row.rateId?.displayName || "-"}
        </MDTypography>
      ),
    },
    {
      field: "isVipParking",
      headerName: "Is Vip Parking",
      width: 120,
      type: "boolean",
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.dark" }}
        >
          {`${row.isVipParking ? "Yes" : "No"} `}
        </MDTypography>
      ),
    },
    {
      field: "isUnitParkingFlow",
      headerName: "Is Unit Parking",
      width: 120,
      type: "boolean",
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.dark" }}
        >
          {`${row.isUnitParkingFlow ? "Yes" : "No"} `}
        </MDTypography>
      ),
    },
    {
      field: "spaceNumber",
      headerName: "Space Number",
      width: 180,
      type: "number",
      editable: false,
      renderCell: ({ row }) => (
        <div
          className="rowscroll"
          style={{ display: "flex", flexDirection: "row" }}
        >
          {(row?.isUnitParkingFlow || row?.isVipParking) && (
            <>
              <MDBadge
                key={Date.now()}
                badgeContent={<p>{row.spaceId?.title || "-"}</p>}
                color={sidenavColor}
                variant="gradient"
                size="sm"
                sx={{ marginRight: 1 }}
              />
              <IconButton
                onClick={() => {
                  setUpdateSpaceNumberData({
                    reservationId: row?._id,
                    spaceId: row?.spaceId?._id,
                  });
                  setSpaceNumberUpdateDialogOpen(true);
                }}
              >
                <Icon fontSize="small">edit</Icon>
              </IconButton>
            </>
          )}
        </div>
      ),
    },
    {
      field: "noOfPasses",
      headerName: "No of Passes",
      width: 150,
      type: "number",
      editable: false,
      renderCell: ({ row }) => (
        <div
          className="rowscroll"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <MDTypography
            display="block"
            variant="caption"
            sx={{ color: "black.light" }}
          >
            {row?.noOfPasses}
          </MDTypography>
        </div>
      ),
    },
    {
      field: "ridersLastName",
      headerName: "Riders Last Name",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <div
          className="rowscroll"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <MDTypography
            display="block"
            variant="caption"
            sx={{ color: "black.light" }}
          >
            {row?.ridersLastName || "-"}
          </MDTypography>
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Cell Phone",
      width: 150,
      type: "number",
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {`${mobileNumberMasking(row?.customerId?.mobile || "")}`}
        </MDTypography>
      ),
    },

    {
      field: "paymentMethodType",
      headerName: "Payment Method",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {row.paymentMethodType === "card"
            ? "Credit Card"
            : row.paymentMethodType === "applePay" ||
                row.paymentMethodType === "apple_pay"
              ? "Apple Pay"
              : row.paymentMethodType === "link"
                ? "Stripe Link"
                : row.paymentMethodType === "googlePay" ||
                    row.paymentMethodType === "google_pay"
                  ? "Google Pay"
                  : row.paymentMethodType === "FREE PARKING"
                    ? "Free Parking"
                    : row.paymentMethodType === "VALIDATION CODE"
                      ? "Validation Code"
                      : row.paymentMethodType === "link"
                        ? "Link"
                        : "N/A"}
        </MDTypography>
      ),
    },

    {
      field: "isValidationApplied",
      headerName: "Validation Applied",
      width: 150,
      editable: false,
      type: "boolean",
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.dark" }}
        >
          {`${row.isValidationApplied ? row.validationCode : "N/A"}`}
        </MDTypography>
      ),
    },
    {
      field: "totalAmount",
      headerName: "Total Amount",
      type: "number",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isValidationApplied &&
          row?.withoutDiscounted?.totalAmount !== row?.totalAmount ? (
            <Stack direction="row" spacing={1}>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light", textDecoration: "line-through" }}
              >
                {`$${centsToDollars(row?.withoutDiscounted?.totalAmount)}`}
              </MDTypography>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {`$${centsToDollars(row?.totalAmount)}`}
              </MDTypography>
            </Stack>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.dark" }}
            >
              {`$ ${centsToDollars(row?.totalAmount)}`}
            </MDTypography>
          )}
        </>
      ),
    },

    {
      field: "baseRate",
      headerName: "Base Rate",
      type: "number",
      width: 100,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isValidationApplied &&
          row?.withoutDiscounted?.baseRate !== row?.baseRate ? (
            <Stack direction="row" spacing={1}>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light", textDecoration: "line-through" }}
              >
                {`$${centsToDollars(row?.withoutDiscounted?.baseRate)}`}
              </MDTypography>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {`$${centsToDollars(row?.baseRate)}`}
              </MDTypography>
            </Stack>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.dark" }}
            >
              {`$ ${centsToDollars(row?.baseRate)}`}
            </MDTypography>
          )}
        </>
      ),
    },

    {
      field: "tax",
      headerName: `Tax`,
      type: "number",
      width: 100,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isValidationApplied &&
          row?.withoutDiscounted?.tax !== row?.tax ? (
            <Stack direction="row" spacing={1}>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light", textDecoration: "line-through" }}
              >
                {`$${centsToDollars(row?.withoutDiscounted?.tax)}`}
              </MDTypography>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {`$${centsToDollars(row?.tax)}`}
              </MDTypography>
            </Stack>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.dark" }}
            >
              {`$ ${centsToDollars(row?.tax)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "cityTax",
      headerName: `City Tax`,
      typr: "number",
      width: 100,
      filterable: false,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isValidationApplied &&
          row?.withoutDiscounted?.cityTax !== row?.cityTax ? (
            <Stack direction="row" spacing={1}>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light", textDecoration: "line-through" }}
              >
                {`$${centsToDollars(row?.withoutDiscounted?.cityTax)}`}
              </MDTypography>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {`$${centsToDollars(row?.cityTax)}`}
              </MDTypography>
            </Stack>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.dark" }}
            >
              {`$ ${centsToDollars(row?.cityTax)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "countyTax",
      headerName: `County Tax`,
      width: 100,
      type: "number",
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isValidationApplied &&
          row?.withoutDiscounted?.countyTax !== row?.countyTax ? (
            <Stack direction="row" spacing={1}>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light", textDecoration: "line-through" }}
              >
                {`$${centsToDollars(row?.withoutDiscounted?.countyTax)}`}
              </MDTypography>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {`$${centsToDollars(row?.countyTax)}`}
              </MDTypography>
            </Stack>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.dark" }}
            >
              {`$ ${centsToDollars(row?.countyTax)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "serviceFee",
      headerName: "Service Fee",
      type: "number",
      width: 100,
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isValidationApplied &&
          row?.withoutDiscounted?.serviceFee !== row?.serviceFee ? (
            <Stack direction="row" spacing={1}>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light", textDecoration: "line-through" }}
              >
                {`$${centsToDollars(row?.withoutDiscounted?.serviceFee)}`}
              </MDTypography>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {`$${centsToDollars(row?.serviceFee)}`}
              </MDTypography>
            </Stack>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.dark" }}
            >
              {`$ ${centsToDollars(row?.serviceFee)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "ownerPayout",
      headerName: "Owner Payout",
      width: 100,
      type: "number",
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isValidationApplied &&
          row?.withoutDiscounted?.ownerPayout !== row?.ownerPayout ? (
            <Stack direction="row" spacing={1}>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light", textDecoration: "line-through" }}
              >
                {`$${centsToDollars(row?.withoutDiscounted?.ownerPayout)}`}
              </MDTypography>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {`$${centsToDollars(row?.ownerPayout)}`}
              </MDTypography>
            </Stack>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.dark" }}
            >
              {`$ ${centsToDollars(row?.ownerPayout)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "primaryConnectAccountPayout",
      headerName: "Client Payout",
      width: 100,
      type: "number",
      editable: false,
      renderCell: ({ row }) => (
        <>
          <MDTypography
            display="block"
            variant="caption"
            sx={{
              color: "black.light",
              // textDecoration: "line-through",
            }}
          >
            {`$${centsToDollars(row?.primaryConnectAccountPayout)}`}
          </MDTypography>
        </>
      ),
    },
    {
      field: "secondaryConnectAccountPayout",
      headerName: "Operator Payout",
      width: 100,
      type: "number",
      editable: false,
      renderCell: ({ row }) => (
        <>
          <MDTypography
            display="block"
            variant="caption"
            sx={{
              color: "black.light",
            }}
          >
            {`$${centsToDollars(row?.secondaryConnectAccountPayout)}`}
          </MDTypography>
        </>
      ),
    },
    {
      field: "dockRevenue",
      headerName: "Dock Revenue",
      width: 250,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <MDTypography variant="caption">
                ${centsToDollars(row?.dockRevenue || 0)}
              </MDTypography>

              {row?.isDockRevenueTransfered ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <Tooltip title="Transfer completed successfully">
                    <Chip
                      icon={<CheckCircleIcon />}
                      label="Transferred"
                      color="success"
                      size="small"
                    />
                  </Tooltip>

                  <Chip
                    label={row?.retryFrom || "Webhook"}
                    size="small"
                    variant="outlined"
                  />
                </Stack>
              ) : row?.dockRevenue > 0 && row.status === "success" ? (
                <Tooltip title="Transfer failed or pending. Click to view details">
                  <Chip
                    icon={<ErrorIcon />}
                    label="Transfer Failed"
                    color="error"
                    size="small"
                    clickable
                    onClick={() => handleViewTransferInfo(row)}
                  />
                </Tooltip>
              ) : (
                <Chip label="No Transfer" size="small" variant="outlined" />
              )}
            </Stack>
          </Box>
        );
      },
    },

    {
      field: "paymentGatewayFee",
      headerName: "Payment Gateway Fee",
      width: 150,
      type: "number",
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isValidationApplied &&
          row?.withoutDiscounted?.paymentGatewayFee !==
            row?.paymentGatewayFee ? (
            <Stack direction="row" spacing={1}>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light", textDecoration: "line-through" }}
              >
                {`$${centsToDollars(
                  row?.withoutDiscounted?.paymentGatewayFee,
                )}`}
              </MDTypography>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {`$${centsToDollars(row?.paymentGatewayFee)}`}
              </MDTypography>
            </Stack>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.dark" }}
            >
              {`$ ${centsToDollars(row?.paymentGatewayFee)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "applicationFee",
      headerName: "Application Fee",
      width: 120,
      type: "number",
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.isValidationApplied &&
          row?.withoutDiscounted?.applicationFee !== row?.applicationFee ? (
            <Stack direction="row" spacing={1}>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light", textDecoration: "line-through" }}
              >
                {`$${centsToDollars(row?.withoutDiscounted?.applicationFee)}`}
              </MDTypography>
              <MDTypography
                display="block"
                variant="caption"
                sx={{ color: "black.light" }}
              >
                {`$${centsToDollars(row?.applicationFee)}`}
              </MDTypography>
            </Stack>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              sx={{ color: "black.dark" }}
            >
              {`$ ${centsToDollars(row?.applicationFee)}`}
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "isExtension",
      headerName: "Extend Reservation ",
      width: 120,
      type: "boolean",
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.dark" }}
        >
          {`${row.parentReservationId ? "Yes" : "No"} ${
            row.parentReservationId
              ? `( ${get(row.parentReservationId, "transientNumber", "")} )`
              : ""
          }`}
        </MDTypography>
      ),
    },
    {
      field: "isBallpark",
      headerName: "Ballparc Status",
      width: 150,
      type: "boolean",
      editable: false,
      renderCell: ({ row }) => (
        <>
          {row.externalKey ? (
            <Tooltip
              title={`${
                !row?.placeId?.ballparc?.isEnable
                  ? "Enable Ballparc First!"
                  : ""
              }`}
              placement="top"
            >
              <div style={{ display: "inline-block", cursor: "pointer" }}>
                <Tooltip
                  title={` Click here to view ballpark status `}
                  placement="top"
                >
                  <Button
                    color="primary"
                    sx={{ textTransform: "none", padding: 0 }}
                    disableRipple
                    disabled={!row?.placeId?.ballparc?.isEnable}
                    onClick={() => {
                      setBallparkView(true);
                      setBallparkData({
                        placeData: row.placeId,
                        externalKey: row.externalKey,
                        reservationId: row._id,
                      });
                    }}
                  >
                    {row?.placeId?.ballparc?.isEnable ? "Yes" : "No"}
                  </Button>
                </Tooltip>
              </div>
            </Tooltip>
          ) : (
            <MDTypography
              display="block"
              variant="caption"
              ml={3}
              sx={{ color: "black.dark" }}
            >
              No
            </MDTypography>
          )}
        </>
      ),
    },
    {
      field: "omniparkStatus",
      headerName: "Omnipark Status",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${row.omniparkStatus || "-"}`}
        </MDTypography>
      ),
    },
    {
      field: "omniparkMessage",
      headerName: "Omnipark Message",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${row.omniparkMessage || "-"}`}
        </MDTypography>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      filterable: false,
      renderCell: ({ row }) => (
        <>
          <Stack direction="row" alignItems="center">
            {row?.paymentId?.paymentStatus === "failed" && (
              <Tooltip
                title={`Click here to view failed reason`}
                placement="top"
              >
                <Button
                  sx={{
                    textTransform: "none",
                    padding: 0,
                    color: "red",
                    fontWeight: "regular",
                  }}
                  disableRipple
                  onClick={() => {
                    setFailedViewReason(true);
                    setFailedReasonData({
                      paymentInfo: get(row?.paymentId, "paymentInfo", {}),
                    });
                  }}
                >
                  Failed Reason
                </Button>
              </Tooltip>
            )}

            {row?.paymentId?.paymentStatus !== "failed" && (
              <Tooltip title="Download Receipt" placement="top">
                <IconButton
                  color="success"
                  onClick={() => {
                    if (row?.receiptURL) {
                      window.open(row?.receiptURL, "_blank");
                    }
                  }}
                >
                  <Icon fontSize="small">download </Icon>
                </IconButton>
              </Tooltip>
            )}

            {roleModules.Reservation_refund &&
              row?.paymentId?.paymentStatus === "success" &&
              row?.paymentId?.isFullyRefunded !== true && (
                <Tooltip title={"Click here to issue refund"} placement="top">
                  <MDButton
                    variant="gradient"
                    onClick={() => {
                      setRefundDialogOpen(true);
                      setIssueRefundData(row);
                    }}
                    fontSize="small"
                    color={sidenavColor}
                  >
                    Issue Refund
                  </MDButton>
                </Tooltip>
              )}
          </Stack>
        </>
      ),
    },
  ];

  const handlePageChange = (params) => {
    getReservationsData(params.page);
    setPage(params.page);
  };

  const handlePageSizeChange = (params) => {
    setPageSize(params.pageSize);
  };

  const getReservationsData = async (pageNo) => {
    const payload = {
      tz,
      pageNo: pageNo || 0,
      status: activeTab,
      placeId,
      search: searchText,
      startDate,
      endDate,
      filterModel:
        filterModel.items.length > 0
          ? {
              items: filterModel.items,
              logicOperator: filterModel.logicOperator || "and",
            }
          : null,
      sortModel: sortModel.length > 0 ? sortModel : null,
    };
    dispatch(getReservations(payload));
  };

  const debounceFn = useMemo(
    () => debounce(getReservationsData, 1000),
    [getReservationsData],
  );

  useEffect(() => {
    debounceFn();
  }, [startDate, endDate, searchText, placeId, reload, filterModel, sortModel]);

  // const getRowClassName = (params) => {
  //   switch (params?.row?.status) {
  //     case "failed":
  //       return activeTab === "all" ? "paymentFailed" : "";
  //     case "refunded":
  //       return activeTab === "all" ? "paymentRefunded" : "";
  //     default:
  //       return "";
  //   }
  // };

  return (
    <>
      <MDBox mt={2}>
        <MDDataGrid
          rows={!isEmpty(reservationsList) ? reservationsList : []}
          rowCount={totalReservations}
          columns={columnsData}
          getRowId={(row) => row._id}
          disableSelectionOnClick
          // loading={loading}
          pagination
          page={page}
          pageSize={pageSize}
          paginationMode="server"
          paginationModel={{ page: page, pageSize: pageSize }}
          onPaginationModelChange={(params) => {
            handlePageChange(params);
          }}
          onPageSizeChange={(params) => handlePageSizeChange(params)}
          // getRowClassName={(params) => getRowClassName(params)}
          components={{
            NoRowsOverlay: EmptyTableRowOverlay,
            LoadingOverlay: LinearProgress,
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: false,
              quickFilterProps: { debounceMs: 1000 },
            },
          }}
          filterModel={filterModel}
          onFilterModelChange={handleFilterChange}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={handleColumnVisibilityChange}
          columnOrder={columnOrder}
          onColumnOrderChange={handleColumnOrderChange}
        />
      </MDBox>
      <CircularIndeterminate
        type="full"
        size={20}
        text="Please wait..."
        open={loading}
      />
      <MDSnackbar
        color={notification.color}
        icon={notification.icon}
        title={notification.title}
        content={notification.content}
        open={notification.show}
        // close={notification.close}
        close={() => setNotification((prev) => ({ ...prev, show: false }))}
        bgWhite
      />
      <RefundDialog
        dialogOpen={refundDialogOpen}
        onClose={() => {
          setRefundDialogOpen(false);
          setFullRefund(false);
        }}
        data={issueRefundData}
        isRefundIssued={isRefundIssued}
        setFullRefund={setFullRefund}
        fullRefund={fullRefund}
        setIsRefundIssued={setIsRefundIssued}
        getReservationsData={getReservationsData}
      />
      <LicensePlateUpdate
        dialogOpen={licensePlateUpdateDialogOpen}
        onClose={() => {
          setLicensePlateUpdateDialogOpen(false);
        }}
        data={updateLicensePlateData}
        getReservationsData={getReservationsData}
      />
      <BallparkDialog
        data={ballparkData}
        setNotification={setNotification}
        dialogOpen={ballparkView}
        setReload={{ setReload, reload }}
        onClose={() => {
          setBallparkView(false);
        }}
      />
      <PaymentFailedInfoDialog
        data={failedReasonData}
        dialogOpen={failedViewReason}
        onClose={() => {
          setFailedViewReason(false);
        }}
      />
      <SpaceNumberUpdate
        dialogOpen={spaceNumberUpdateDialogOpen}
        onClose={() => {
          setSpaceNumberUpdateDialogOpen(false);
        }}
        data={updateSpaceNumberData}
        getReservationsData={getReservationsData}
        placeId={placeId}
      />
      <ConfirmationDialog
        dialogOpen={retryDialogOpen}
        onClose={() => {
          setRetryDialogOpen(false);
          setRetryTransferRow(null);
        }}
        dialogTitle="Retry Dock Revenue Transfer"
        confirmationText="Are you sure you want to retry dock revenue transfer?"
        buttonLabel={retryLoading ? "Retrying..." : "Retry"}
        btnColor="error"
        action={handleRetryTransfer}
      />
      <DockTransferInfoDialog
        open={transferInfoOpen}
        loading={transferInfoLoading}
        transferInfo={transferInfo}
        onClose={() => {
          setTransferInfoOpen(false);
          setTransferInfo(null);
        }}
        onRetry={() => {
          setRetryTransferRow(selectedTransferRow);
          setRetryDialogOpen(true);
        }}
      />
    </>
  );
};

export default ReservationsTable;
